import { createRouter, createWebHistory } from 'vue-router';

const autoRouter = ({ prependSlash }) => ({
  path: (prependSlash ? '/' : '') + ':slug(.*)',
  props: true,
  name: 'AutoRouter',
  component: () =>
    import(/* webpackChunkName: "about" */ '../views/AutoRouter.vue')
});

const landingConfig = ({ prependSlash }) => ({
  path: (prependSlash ? '/' : '') + 'landing/:slug(.*)',
  props: true,
  component: () =>
    import(/* webpackChunkName: "about" */ '../views/Landing.vue')
});

const createFinalRouter = (app, store, axiosClient) => {
  const routes = [
    { path: 'vorteile', redirect: { path: '/funktionen' } },
    { path: 'fr/avantages', redirect: { path: '/fr/fonctions' } },
    { path: 'it/vantaggi', redirect: { path: '/it/funzioni' } },
    autoRouter({ prependSlash: false }),
    landingConfig({ prependSlash: false, app }),
    {
      path: ':pathMatch(.*)*',
      name: 'NotFoundInLang',
      meta: {
        pageID: 'notfound'
      },
      component: () =>
        import(/* webpackChunkName: "notfound" */ '../views/404.vue')
    }
  ];
  var langRoutes = [
    {
      path: '/:locale(fr|it|)?',
      name: 'Base',
      children: routes
    }
  ];

  const router = createRouter({
    history: createWebHistory(process.env.VUE_BASE_URL),
    routes: langRoutes,
    scrollBehavior: (to, from) => {
      var hash = to.hash;
      if (hash) {
        return {
          el: to.hash
        };
      } else {
        return {
          top: 0
        };
      }
    }
  });

  router.beforeEach(async (to, from, next) => {
    const locale = to.params.locale || 'de';
    document.documentElement.setAttribute('lang', locale + '-CH');
    await axiosClient.$loadGeneral(locale);
    if (to.name != 'NotFoundInLang') {
      const pageData = await axiosClient.$loadPageByUrl(to.fullPath, true);
      if (pageData) {
        //setting seo data and alternate lang urls
        app.config.globalProperties.$store.state.alternateLinks =
          pageData.seo.urls;
        document.title = pageData.seo.title;

        store.state.currentPageData = pageData;
        if (window.fbq)
          window.fbq('track', 'PageView', {
            page_url: to.fullPath,
            page_title: pageData.seo.title
          });
        next();
      } else {
        app.config.globalProperties.$store.state.alternateLinks = null;
        next({
          name: 'NotFoundInLang',
          params: {
            pathMatch: [...to.fullPath.split('/').filter(Boolean)]
          }
        });
      }
    } else {
      next();
    }
  });

  return router;
};
export default createFinalRouter;
